<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  // Whether or not the drawer is currently collapsed
  export let isCollapsed = true;

  // Whether or not to display the handle when in colapsed state
  export let displayHandle = true;

  // The number of pixels the touch has to travel for the drawer to toggle
  // after the touch ends
  export let toggleThreshold: number = 10;
  export let collapsable: boolean = true;
  export let isBeingDragged: boolean = false;
  export let bg = 'bg-white';
  export let isFullyHide = false;
  const dispatch = createEventDispatcher();

  let containerTransform = { translateY: 1000 };

  let marginTop;

  $: if (container) {
    handleIsCollapsedChange();
  }

  $: if (isCollapsed && collapsable) {
    dispatch('drawerCollapsed');
  } else if (isCollapsed) {
    isCollapsed = false;
  } else {
    dispatch('drawerDecollapsed');
  }

  const handleIsCollapsedChange = () => {
    if (isCollapsed) {
      if (isFullyHide) {
        marginTop = container.clientHeight;
      } else {
        marginTop = container.clientHeight + (displayHandle ? -10 : 20);
      }
    }
  };

  let container: HTMLElement;
  let handle: HTMLElement;
  let lastTouchDown;
  let lastTouchMove;
  let animation;

  const getEventClientY = event => {
    return event.clientY ?? event.touches[0].clientY;
  };

  const handleTouchDown = event => {
    event.preventDefault();
    isBeingDragged = true;
    animation.pause();
    lastTouchDown = event;
    lastTouchMove = event;
    document.addEventListener('mousemove', handleTouchMove);
    document.addEventListener('mouseup', handleTouchUp);
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchUp);
  };

  const handleTouchUp = () => {
    isBeingDragged = false;
    document.removeEventListener('mousemove', handleTouchMove);
    document.removeEventListener('mouseup', handleTouchUp);
    document.removeEventListener('touchmove', handleTouchMove);
    document.removeEventListener('touchend', handleTouchUp);
    const deltaY = getEventClientY(lastTouchDown) - getEventClientY(lastTouchMove);
    if (deltaY > toggleThreshold && isCollapsed) {
      isCollapsed = false;
    } else if (isCollapsed) {
      isCollapsed = false;
      isCollapsed = true;
    } else if (deltaY < -toggleThreshold && !isCollapsed) {
      isCollapsed = true;
    } else if (!isCollapsed) {
      isCollapsed = true;
      isCollapsed = false;
    }
  };

  const handleTouchMove = event => {
    const deltaY = getEventClientY(event) - getEventClientY(lastTouchMove);
    if (containerTransform.translateY + deltaY < 0) {
      containerTransform.translateY = 0;
    } else {
      containerTransform.translateY = Math.max(50, containerTransform.translateY + deltaY);
      lastTouchMove = event;
    }
  };
</script>

<div
  class="fixed bottom-1 left-0 z-30 max-h-[800px] flex flex-col w-full select-none rounded-t-30 {bg} {$$props.class}"
  bind:this={container}
  style="transform: translateY({containerTransform.translateY / 90}px); will-change: transform"
>
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    bind:this={handle}
    on:mousedown={handleTouchDown}
    on:touchstart={handleTouchDown}
    class="flex-grow-0 cursor-pointer pointer-events-auto rounded-t-[30px]"
  >
    <slot name="handle" />
  </div>
  <div class="mb-5 h-full overflow-scroll">
    <slot name="content" />
  </div>
</div>
